var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarP = function SvgDefaultAvatarP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_p_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_p_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 55.3c4.5 0 6.8-.4 6.8-1.6 0-.9-1.1-1.2-3.7-1.3-.5-.2-.7-2.1-.7-4.5v-4.2c1.6.2 3.3.3 4.5.3 6.6 0 11.5-3.7 11.5-9.8 0-4.9-3-9.1-11.3-9.1-1.8 0-4.3.2-5.5.2H33c-3.1 0-5 .3-5 1.5 0 .9 1 1.2 3.1 1.3.5.2.6 2.1.6 4.5v15.3c0 2.9-.1 4.3-.6 4.5-2.2.1-3.2.4-3.2 1.3 0 1.2 2.2 1.6 6.3 1.6zm2.5-14.5v-8.2c0-2.4.1-3.9.5-4.3.9-.3 2.1-.4 3.3-.4 5.6 0 6.8 3.4 6.8 6.8 0 4.1-2.1 6.5-6.7 6.5-1.2 0-2.5-.1-3.9-.4z"
  })));
};
export default SvgDefaultAvatarP;